var _path, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIsland2 = function SvgIsland2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 67,
    viewBox: "0 0 241 67",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275 42H0C1.43509 43.6464 5.34573 47.548 9.5075 49.9831C14.7097 53.027 25.2935 53.8311 42.5147 53.8311C59.7358 53.8311 58.3007 61.1825 87.182 66.1217C116.063 71.0609 170.059 53.5439 199.837 53.8311C229.615 54.1182 240.02 43.3784 252.935 45.3885C263.268 46.9966 271.95 43.7996 275 42Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275 42H0C1.43509 39.2341 5.34573 32.6794 9.5075 28.5884C14.7097 23.4746 25.2935 22.1238 42.5147 22.1238C59.7358 22.1238 58.3007 9.77339 87.182 1.47553C116.063 -6.82234 170.059 22.6062 199.837 22.1238C229.615 21.6414 240.02 39.6843 252.935 36.3073C263.268 33.6056 271.95 38.9767 275 42Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 137.5,
    y1: 67,
    x2: 145.076,
    y2: 17.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779A4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 137.5,
    y1: -0.00000196032,
    x2: 158.018,
    y2: 79.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80A587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779A4",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIsland2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/island2.8e197831.svg";
export { ForwardRef as ReactComponent };